/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetUserSessionsRequest} from '@cash-web/protos/squareup/cash/kgoose/api/v3/session_messages.pb'
import {GetUserSessionsResponse} from '@cash-web/protos/squareup/cash/kgoose/api/v3/session_messages.pb'


export const getUserSessions = (request: GetUserSessionsRequest, options?: CashRequestOptions) => post<GetUserSessionsRequest, GetUserSessionsResponse>("/cash-app/goose-cash/v3/get-user-sessions", request, {...options, rejectOnError: true })